import { RELEASE_ANNOUNCEMENT } from '../types'
export default (state = {}, action) => {
  switch (action.type) {
    case RELEASE_ANNOUNCEMENT:
      return action.payload
    default:
      return state;
  }
}
